<template>
<div>
  <div class="wrapper">
    <div class="main-top">
      <el-row type="flex" align="middle" justify="space-between">
        <div class="mtl-wrap">
          <div class="mtl">
            <router-link to="/">
              <div class="logo-icon">
                <!-- <img src="@/assets/images/sld.jpg" alt> -->
				<img :src="LogoImg" alt>
				
              </div>
              <!-- <div class="logo-text">{{$store.state.config.shop_name}}</div> -->
            </router-link>
          </div>
        </div>
        <el-input :placeholder="$t('pleaseEnterContent')" v-model="input3"  class="input-with-select">
          <el-select v-model="select" slot="prepend" :placeholder="$t('pleaseSelect')">
            <!-- 商品 -->
            <el-option :label="$t('select.option1')" value="1"></el-option>
            <!-- 视频 -->
            <el-option :label="$t('select.option2')" value="2"></el-option>
            <!-- 行业资讯 -->
            <el-option :label="$t('select.option3')" value="3"></el-option>
            <!-- 常见问题 -->
            <el-option :label="$t('select.option4')" value="4"></el-option>
            <!-- 照片墙 -->
            <el-option :label="$t('select.option5')" value="5"></el-option>
          </el-select>
          <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
        </el-input>
        <!--<div class="coupon-wrap-top">
          <share />
        </div>-->
        <div class="cars-nums" @click="goCart" style="display: flex;align-items: center; margin-top: inherit"> 
          <img class="iconcart"  style="width: 25px; height: 25px;" src="@/assets/images/cart.png" alt="">&nbsp;&nbsp;My {{$t('cart')}} 
          <!-- 购物车 -->
        <!--<span style="margin: 0 4px">  {{$store.state.cartNums || 0}}  </span>  {{$t('piece')}}--></div>

      </el-row>


    </div>
    <el-collapse-transition>
      <div class="tui-wrap" v-show="showDraw" @mouseover="showDraw=true" @mouseleave="showDraw=false">
        <div class="tui-main">
          <el-carousel indicator-position="outside" style="width:100%;height:100%;">
            <el-carousel-item v-for="(item,i) in resultList" :key="i" class="list">
              <div v-for="(shop,index) in item" :key="index" class="pro" style="float:left">
                 <a href="javascript:;" @click="lookDetail(shop.id)">
                  <div class="pro-img" v-show="shop.image_url">
                    <img v-lazy="shop.image_url" :alt="shop.name" :key="shop.image_url">
                  </div>
                  <div class="title">{{shop.name}}</div>
                  <div class="price">{{shop.price}}</div>
               </a>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </el-collapse-transition>
    <div class="top-nav" :style="{background: !all ? 'none' : '#212121'}">
      <div class="nav-wrap main-top">
        <el-row type="flex" align="middle" justify="space-between" class="mtr" >
          <div class="nav">

            <div class="nav-item all active" 
            :class="{'active':this.$route.name!=='home'}"  @mouseover="togglePanel(true)" @mouseleave="togglePanel(false)">
              <!-- 全部视频分类 -->
              <span v-if="$route.name == 'video' || $route.name == 'classify'">{{$t('allvideocategories')}} </span>
              <!-- 全部商品分类 -->
              <span v-else>{{$t('totaCommodityClassification')}}  </span>

              <div class="nav-wrap" v-show="showAllNav">
                <all-classify></all-classify>
              </div>
            </div>
            <template v-if="shopMenu.menu">
              <div class="nav-item"  v-for="(item,index) in shopMenu.menu.nav" :key="index"
              :class="{active: item.val == ('/web/#' + routeName) }"
               @mouseover="changeNav(item)" @mouseleave="showDraw=false">
                <template v-if="item.type==4">
                  <!--商品列表 -->
                  <a href="javascript:;" @click="searchItem(item)">
                    <span>{{item.name}} </span>
                  </a>
                </template>
                <template v-else-if="item.type==1">
                  <!--url -->
                  
                    <a :href="item.data" >
                      <span>{{item.name}}</span>
                    </a>
                  
                </template>
                <template v-else-if="item.type==3">
                  <!--文章详情 -->
                  <span @click="toArticle(item)">{{item.name}}</span>
                </template>
                <template v-else-if="item.type==2">
                  <!--文章分类 -->
                  <router-link :to="{name:'help',query:{type:item.type,id:item.data}}">{{item.name}}</router-link>
                </template>
                <template v-else-if="item.type==5">
                  <!--商品详情 -->
                  <router-link :to="{name:'detail',params: {goodsId:item.val}}">{{item.name}}</router-link>
                </template>
                <template v-if="item.type==6">
                  <!--二级菜单 -->
                  <a href="javascript:;">
                    <span>{{item.name}}</span>
                  </a>
                </template>
              </div>
            </template>
          </div>
        </el-row>
      </div>
    </div>
  </div>

  <el-dialog :title="$t('getCoupons')" :visible.sync="centerDialogVisible" width="400px" center>
      <div class="coupon-list">
        <div class="coupon-wrap" v-for="(item,index) in couponList" :key="index">
          <div class="content">
            <div class="price">
              <span class="num">{{item.name}}</span>
            </div>
            <div class="desc">{{item.expression1}}&nbsp;&nbsp;{{item.expression2}}</div>
            <div class="time">{{item.stime}}&nbsp;--&nbsp;{{item.etime}}</div>
          </div>
          <div class="status">
            <a href="javascript:;" @click="userGetCoupon(item.id)">{{$t('get')}}</a>
          </div>
        </div>
      </div>
    </el-dialog>
</div>
</template>
<script>
import AllClassify from '@/components/common/AllClassify.vue'
import Share from '@/components/common/Share.vue'

import { mapState } from 'vuex'
export default {
  name: 'MainTop',
  components: {
    AllClassify,
    Share
  },
  data() {
    return {
      keywords: null,
      showDraw: false,
      input: '',
      inputFocus: false,
      showAllNav: false,
      proList: [],
      menuTopList: [],
      resultList: [],
      select: this.$t('pleaseSelect'),
      selectinput: '',
      input3: '',
      select: '1',
      all: false,
      videoMenu: [], // 视频分类
      centerDialogVisible: false,
      couponList: [], //优惠券列表
      routeName: '/',
	  LogoImg:''
    }
  },
  computed: {
    ...mapState({
      shopMenu: state => state.shopMenu,
    }),
  },
  watch: {
    '$route'() {

      this.routeName = this.$route.fullPath
      let {name} = this.$route
      if (this.$route.params.key) {
        this.input = this.$route.params.key
      }
      this.showAllNav = this.$route.meta.showAllNav
      this.all = this.$route.meta.all 


      if(this.$route.name == 'video' ||this.$route.name == 'videodetail' || this.$route.name ==  'videoclassify') {
        this.select = '2'
      }

      if(this.$route.name == 'articleIndex' ||this.$route.name == 'articledetail') {
        this.select = '3'
      }

      if( this.$route.name == 'help' || this.$route.name ==  'helpdetail' ) {
        this.select = '4'
      }

      if( this.$route.name == 'pictureIndex' || this.$route.name ==  'picturedetail' ) {
        this.select = '5'
      }
	  
	  //console.log(this.$route.name);
	   
      // if(this.$route.name == 'video') {
      //   this.videoclassify()
      // }
    },
  },
  mounted() {
    if(this.$route.meta.showAllNav) {
      this.showAllNav = true
    }
    // if(this.$route.name == 'video') {
    //   this.videoclassify()
    // }
    if(this.$route.meta.all) {
      this.all = true
    }
  },
  created() {
	let timeS = new Date().getTime()
	this.LogoImg = 'https://www.sanlidaoutdoor.com/static/images/logo/sld_logo.jpg?' + timeS
    this.$api.getRecommendKeys().then(res => {
      if (res.status) {
        this.keywords = res.data
      }
    })
    this.getCoupon()
  },
  methods: {
    showCoupon() {
      if(this.couponList.length>0){
        this.centerDialogVisible=true
      }
    },
    // 获取商户优惠券信息
    getCoupon() {
      this.$api.couponList().then(res => {
        if (res.status) {
          this.couponList = res.data;
        }
      });
    },
    //领取优惠券
    userGetCoupon(id) {
      this.$api.getCoupon({ promotion_id: id }).then(res => {
        if(res.status){
          this.$msg(res.msg)
        }else{
          this.$msg(res.msg,'warning')
        }
        // this.centerDialogVisible=false;
      });
    },
    // videoclassify() {
    //   this.$api.getcourselist().then(res => {
    //     if(res.status) {
    //       this.videoMenu =  res.data.list
    //     }
    //   })
    // },
    search() {

      if(!this.select) {
        this.$message({
          message: this.$t('pleaseSelect'),
          type: 'warning'
        })
        return
      }
      // if(!this.input3) {
      //    this.$message({
      //     message: this.$t('pleaseEnterContent'),
      //     type: 'warning'
      //   })
      //   return
      // }
      switch (this.select) {
        case '1':
          this.$router.push({
            path: '/search',
            query: {
              search_name: this.input3,
              key: this.input3, name: this.input3
            }
          })
          break;
        case '2': 
          this.$router.push({
            path: '/videoclassify',
            query: {
              search_name: this.input3
            }
          })
          break;
        case '3': 
          this.$router.push({
            path: '/article/index',
            query: {
              search_name: this.input3
            }
          })
          break;
        case '4': 
          this.$router.push({
            path: '/help',
            query: {
              search_name: this.input3
            }
          })
          break;
        case '5': 
          this.$router.push({
            path: '/picture/index',
            query: {
              search_name: this.input3
            }
          })
          break;
        default:
          break;
      }
    },
    goCart() {
      this.$router.push({
        path: "/cart"
      })
    },
    togglePanel(val) {
      if(this.$route.meta.showAllNav) {
        return
      }
      this.showAllNav = val
    },
    //查看文章
    toArticle(item) {
      this.$router.push({
        name: 'help',
        query: { id: item.data, type: item.type },
      })
      this.showDraw = false
    },
    searchItem(item) {
      console.log(item)
      this.$router.push({
        name: 'search',
        query: { id: item.id, name: item.name },
      })
      this.showDraw = false
    },
    changeNav(item) {
      // if (
      //   item.data &&
      //   item.data.constructor &&
      //   item.data.constructor === Array &&
      //   item.data.length > 0
      // ) {
      //   this.showDraw = true
      //   this.proList = item.data
      //   console.log(this.proList)
      //   var result = []
      //   for (var i = 0, len = this.proList.length; i < len; i += 6) {
      //     result.push(this.proList.slice(i, i + 6))
      //   }
      //   // console.log(result)
      //   this.resultList = result
      // } else {
      //   this.showDraw = false
      // }
    },
    lookDetail(id) {
      this.showDraw = false
      this.$router.push({ name: 'detail', params: { goodsId: id } })
    },
    jumpToSearch() {
      if (this.input) {
        this.$router.push({
          name: 'search',
          query: { key: this.input, name: this.input },
        })
      }
    },
  },
}
</script>

<style >

.main-top .el-input-group > .el-input__inner {
  border: none;
}
</style>
<style lang="scss" scoped>
.coupon-wrap-top {
  width: 200px;
  height: 40px;
}
.coupon {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.main-top {
  .input-with-select {
    border: 2px solid #e7442f
  }
  .el-input-group__append {
    .el-button {
      background: #e7442f;
      border-radius: 0;
      height: 44px;
      margin-right: -22px;
      color: #fff;
    }
  }
}

@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
.cars-nums {
  justify-content: center;
  cursor: pointer;
  float: right;
  width: 190px;
  height: 35px;
  display: inline;
  margin-top: 10px;
  background: #f5f5f5  no-repeat 25px 8px;
  // padding-left: 55px;
  line-height: 35px;
  font-size: 14px;
  box-sizing: border-box;
}
.wrapper {
  width: 100%;
  background: #fff;
  position: relative;
  .main-top {
    width: 1226px;
    margin: 0 auto;
    height: 100px;
    padding: 0;
    .el-row {
      height: 100%;
      .mtl-wrap {
        width: 234px;
      }
      .mtl {
        a {
          display: inline-flex;
          align-items: center;
        }
        .logo-icon {
          width: 200px;
          height: 60px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .logo-text {
          font-size: 15px;
          padding: 0 10px;
          @include line-height(24px);
          color: rgba(51, 51, 51, 1);
        }
      }
      .mtr {
        flex: 1;
        .nav {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 100px;
          .nav-item {
            height: 100px;
            line-height: 100px;
            text-align: center;
            cursor: pointer;
            font-size: 16px;
            a {
              display: block;
            }
            &:first-of-type {
              span {
                padding-left: 0;
              }
            }
            
            span {
              display: block;
              padding: 0 18px;
              &:hover {
                color: $theme-color;
              }
            }
          }
        }
        .search {
          width: 295px;
          height: 50px;
          background: rgba(255, 255, 255, 1);
          border: 1px solid rgba(220, 220, 220, 1);
          padding: 10px 0 10px 10px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all 0.2s;
          position: relative;
          &.active {
            border: 1px solid $theme-color;
          }
          .search-input {
            display: block;
            flex: 1;
            height: 20px;
          }
          .search-icon-wrap {
            display: inline-block;
            width: 50px;
            height: 50px;
            position: relative;
            border-left: 1px solid rgba(220, 220, 220, 1);
            transition: all 0.2s;
            cursor: pointer;
            &:hover {
              color: #fff;
              background: $theme-color;
            }
            &.active {
              border-color: $theme-color;
            }
            .search-icon {
              position: absolute;
              width: 20px;
              height: 20px;
              top: 15px;
              left: 15px;
              .el-icon-search {
                font-size: 20px;
              }
            }
          }
          .tip-search {
            position: absolute;
            top: 15px;
            right: 60px;
            height: 16px;
            line-height: 16px;
            font-size: 10px;
            a {
              display: inline-block;
              padding: 0 6px;
              background: #eee;
              color: #757575;
              margin-left: 5px;
              transition: all 0.2s;
              &:hover {
                color: #fff;
                background: $theme-color;
              }
            }
          }
        }
      }
    }
  }
  .tui-wrap {
    position: absolute;
    top: 100px;
    left: 0;
    z-index: 999;
    width: 100%;
    border-top: 1px solid $bc-l;
    background: #fff;
    box-shadow: 0 3px 4px rgba(0, 0, 0, 0.18);
    box-sizing: border;
    .tui-main {
      width: 1226px;
      height: 100%;
      height: 250px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-start;
      flex-flow: row wrap;
      overflow: hidden;
      box-sizing: border;
      .pro {
        width: 204px;
        position: relative;
        padding-top: 35px;
        box-sizing: border-box;
        text-align: center;
        &:not(:last-of-type):after {
          content: '';
          display: block;
          width: 1px;
          height: 100px;
          background: $bc-l;
          position: absolute;
          right: 0;
          top: 38px;
        }
        a {
          display: block;
          width: 100%;
          height: 100%;
          .pro-img {
            width: 110px;
            height: 110px;
            margin: 0 auto 20px;
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .title {
            color: #333;
            font-size: 12px;
            line-height: 16px;
            width: 80%;
            color: #666;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-align: left;
            height: 32px;
            margin: 10px auto;
          }
          .price {
            color: $theme-color;
            font-size: 14px;
          }
          .tag {
            position: absolute;
            top: 0px;
            left: 50%;
            width: 66px;
            height: 22px;
            line-height: 22px;
            border: 1px solid $theme-color;
            color: $theme-color;
            font-size: 12px;
            margin-left: -33px;
          }
        }
      }
    }
  }
  // .nav-item.all {
  //   position: relative;
  //   display: none;
  //   .nav-wrap {
  //     position: absolute;
  //     top: 100px;
  //     left: -70px;
  //     height: 440px;
  //   }
  // }
  .nav-item.all.active {
    display: block;
  }
}

.input-with-select{
  width: 690px;
}

.top-nav {
  width: 100%;
  height: 40px;
  border: 0;
  margin-top: 10px;
  background: #212121;
  .nav-wrap {
    width: 1226px;
    margin: 0 auto;
    height: auto;
    position: relative;
    background: #212121;
    .nav {
      height: 40px;
      display: flex;
      align-items: center;
      &-item {
        color: #fff;
        height: 40px;
        line-height: 40px;
        text-align: center;
        padding: 0 30px;
        &.all {
          width: 184px;
          background: $theme-color;
          cursor: pointer;
          padding: 0 25px !important;
        }

        &.active {
          background: #e7442f;
        }
      }
    }
  }
}
.input-with-select {
  // width: 600px;
  margin-left: -40px;
}
.el-select {
  width: 230px;
}

.coupon-wrap:nth-child(3n+3) {
  margin-right: auto;
}
</style>


